import { render, staticRenderFns } from "./TPerformanceImprovementPlans.vue?vue&type=template&id=38a44d9b&scoped=true"
import script from "./TPerformanceImprovementPlans.vue?vue&type=script&lang=js"
export * from "./TPerformanceImprovementPlans.vue?vue&type=script&lang=js"
import style0 from "./TPerformanceImprovementPlans.vue?vue&type=style&index=0&id=38a44d9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a44d9b",
  null
  
)

export default component.exports